export const dataSourceStatus = {
    active: { label: 'Active', value: 'active' },
    inactive: { label: 'Inactive', value: 'inactive' },
};

export const dataSourceActions = {
    deactivate: 'Deactivate',
    restore: 'Restore',
};

export const dataSourceLogActions = {
    created: 'created',
    deactivated: 'deactivated',
    restored: 'restored',
    modified: 'modified',
    removed: 'removed',
};
